<template>
  <div id="app">
    <router-view />
    <div class="cookie" v-if="cookieflag">
      <!-- <div class="cookie_title">We use cookies</div> -->
      <div class="cookie_content">
        <div>
          Welcome to visit our website. We use cookies to improve website
          performance and your online experience. For more information, see our
          <a href="../../static/policy/Privacy_Cookie_Policy.docx">
            <span style="font-size: bolder">Privacy & Cookie Policy</span>
          </a>
          . Please note that if you refuse cookies, it may affect site
          functionality and performance. The website's
          <a href="../static/policy/Terms_of_Use.docx">
            <span style="font-size: bolder">Terms of Use</span>
          </a>
          and
          <a href="../static/policy/Privacy_Cookie_Policy.docx">
            <span style="font-size: bolder">Privacy & Cookie Policy</span>
          </a>
          has been updated.
        </div>
        <div class="cookie_btn">
          <div class="cookie_btn_action">
            <button @click="acceptCookie(1)" class="button disagree">
              Reject
            </button>
          </div>
          <div class="cookie_btn_action">
            <button @click="acceptCookie(2)" class="button">Accept</button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cookieflag: localStorage.getItem("silicarise_cookie_setting") == null,
    };
  },
  methods: {
    acceptCookie: function (flag) {
      console.log(111);
      localStorage.setItem("silicarise_cookie_setting", flag);
      this.cookieflag = false;
    },
  },
};
</script>
<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  -ms-touch-action: none;
}

html,
body {
  -webkit-text-size-adjust: none;
  margin: 0;
  height: 100%;
  font-size: 14px !important;
  font-family: "Verdana pro" "Verdana", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

html ::-webkit-scrollbar,
body ::-webkit-scrollbar {
  width: 0;
}

ul,
ol {
  list-style: none;
}

a {
  color: #32adc6;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

button {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

input,
button,
textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  outline: none;
}

input:active,
textarea:active,
select:active {
  border: none;
}

input,
textarea,
select {
  font-size: 14px;
}

img {
  border: none;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
}

input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
}

input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.zui-page {
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
  font-family: "Verdana", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.zui-page.min-1200 {
  min-width: 1200px;
}

.zui-page a:hover {
  color: #35a3ba;
  text-decoration: underline;
}

.zui-page .clear:after {
  content: "";
  display: table;
  clear: both;
}

img {
  border: none;
}

.button {
  color: #fff;
  font-size: 14px;
  line-height: 50px;
  border-radius: 6px;
  background: #054589;
  min-width: 190px;
  cursor: pointer;
}

.button.disagree {
  color: gray !important;
  font-size: 14px;
  line-height: 50px;
  border-radius: 6px;
  background: #fff !important;
  min-width: 190px;
  cursor: pointer;
}

.cookie {
  position: fixed;
  bottom: 0;
  background-color: #7b868f;
  padding: 20px 20px 0 20px;
  color: #ffffff;
  width: 100%;
}

.cookie .cookie_title {
  font-size: 25px;
}

.cookie .cookie_content {
  font-size: 16px;
  padding: 10px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.cookie .cookie_btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  // float: right;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.cookie .cookie_btn .cookie_btn_action {
  padding: 0 10px;
}

@media (max-width: 480px) {
  .cookie .button {
    min-width: 100px;
  }

  .cookie {
    position: fixed;
    bottom: 0;
    background-color: #7b868f;
    padding: 10px 10px 0 10px;
    color: #ffffff;
    width: 100%;
  }

  .cookie .cookie_title {
    font-size: 18px;
  }

  .cookie .cookie_content {
    font-size: 12px;
    padding: 10px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .cookie .cookie_btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    float: unset;
    text-align: center;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    width: 100%;
  }

  .cookie .cookie_btn .cookie_btn_action {
    padding: 10px 0;
    display: block;
    width: 100%;
  }

  .cookie .cookie_btn .cookie_btn_action .button {
    min-width: 100px;
  }
}

.career-page {
  display: flex;
  flex-direction: column;
}

/*.menu-logo{
    width: 60px;
    height: 60px;
    background: url(./assets/159.jpg) no-repeat;
    background-size: 100% auto;
    float: right;
    margin-right: 20px;
    margin-top: 7px;
  }*/
</style>
